// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/less/app_color3.less
// module id = ./resources/assets/less/app_color3.less
// module chunks = 0